import React from 'react';
import './ServicesSection.css';
import { services } from '../../assets/exports';

const ServicesSection = () => {
  return (
    <section className="services">
      <div className="services-wrapper">
        <h2 className="services-section-title">Our Core Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;